import type { FC } from 'react';
import {
    Card,
    CardBody,
    Separator,
    SkeletonAvatar,
    SkeletonLine,
    Transaction,
    TransactionGroup,
} from '@george-labs.com/design-system';

const DEFAULT_NUMBER_OF_TRANSACTIONS = 1;

interface Props {
    'data-cy'?: string;
    className?: string;
    numberOfTransactions?: number;
    showDate?: boolean;
}

export const TransactionListSkeleton: FC<Props> = ({
    'data-cy': dataCy,
    className,
    numberOfTransactions = DEFAULT_NUMBER_OF_TRANSACTIONS,
    showDate = true,
}) => (
    <Card data-cy={dataCy} className={className} nested={false}>
        <CardBody>
            <SkeletonLine level={3} animated percentageWidth={20} />
        </CardBody>
        <Separator />
        <TransactionGroup columns={{ date: { show: showDate } }} noGroup>
            {[...Array(numberOfTransactions).keys()].map((i) => (
                <Transaction
                    key={`transaction-list-skeleton-${i}`}
                    avatar={<SkeletonAvatar animated size={SkeletonAvatar.SIZE.SIZE_48} />}
                    renderDate={() => <SkeletonLine level={5} animated />}
                    title={<SkeletonLine animated level={4} />}
                    info={<SkeletonLine level={6} percentageWidth={10} animated />}
                />
            ))}
        </TransactionGroup>
    </Card>
);
